import React from 'react';

import {
  AdministratorInvitesWidgetDocument,
  StoreSettingsActivity_UsersTabDocument,
  useInviteUserMutation
} from 'generated/graphql';

import * as types from './types';



export function useInviteUser(storeId?: string) {
  const refetchQueries = storeId ? [
    {
      query: StoreSettingsActivity_UsersTabDocument,
      variables: {
        storeId
      }
    }
  ] : [
    {
      query: AdministratorInvitesWidgetDocument,
      variables: {}
    }
  ];

  const [fnMutate, tuple] = useInviteUserMutation({
    awaitRefetchQueries: true,
    refetchQueries
  });



  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            storeId,
            recipientEmail: formState.email
          }
        }
      });
    },
    [
      storeId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      tuple,
      fnWrappedMutate
    ]
  );
}
